import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HelpMenuDialogService {
  public menus: any = []; //eslint-disable-line
  private readonly helpAssetsPrefix = '/en/assets/persistent';

  constructor(private http: HttpClient) {}

  loadHelpMenuData(configName: string): void {
    this.http
      .get(this.helpAssetsPrefix + '/' + configName, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate'
        }
      })
      .subscribe(success => {
        return this.loadHelpSubMenuData(success.valueOf());
      });
  }

  loadHelpSubMenuData(config: any, usePrefixURL = true): any {
    for (let i = 0; i < config['sources'].length; i++) {
      const documentURL = usePrefixURL
        ? this.helpAssetsPrefix + config['sources'][i].url
        : config['sources'][i].url;
      this.http
        .get(documentURL, {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate'
          }
        })
        .subscribe(response => {
          this.menus[i] = response.valueOf();
        });
    }
    return this.menus;
  }
}
